const formRows = [{
    span: 24,
    label: '平台名称',
    component: 'AInput',
    placeholder: '请输入平台名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 24,
    label: '平台链接',
    component: 'AInput',
    placeholder: '请输入平台链接',
    prop: 'link',
    allowClear: true
  },
  {
    span: 24,
    label: '内容',
    component: 'RichTextEdit',
    prop: 'brief',
  }
]
const formRules = {
  name: [{
      required: true,
      message: '平台名称不能为空',
      trigger: 'blur'
    },
    {
      min: 1,
      max: 100,
      message: '输入的字数不能超过100个',
      trigger: 'blur'
    }
  ],
  link: [{
    required: false,
    message: '平台链接不能为空',
    trigger: ['blur']
  }]
}

const formInfo = [{
    label: '平台名称',
    value: '-',
    key: 'name'
  },
  {
    label: '平台链接',
    value: '-',
    key: 'link'
  },
  {
    label: '内容简介',
    value: '-',
    key: 'content',
    isVHtml: true
  }
]

module.exports = {
  formRows,
  formRules,
  formInfo
}